<template>
  <div class="ws-read-tab">
    <WsCarousel
      :menuData="tabItems"
      @input="$_onTabInput($event)"
    ></WsCarousel>
    <div
      v-for="(item,itemIndex) in tabSetting"
      :key="itemIndex"
    >
      <WsDataExpandList
        v-show="itemIndex===_tabCheckedIndex"
        :modelName="item.modelName"
        :label="item.label"
        :parentModelName="item.parentModelName"
        :parentState="item.parentState"
        :locale="item.locale"
        :fields="item.fields"
        :titleKey="item.titleKey"
        :searchMode="item.searchMode"
        :batchMode="item.batchMode"
        :fieldsRead="item.fieldsRead"
        :modeVersions="item.modeVersions"
        :rootModelName="item.rootModelName"
        :modelData="modelData"
        :orderBy="item.orderBy"
        :orderWay="item.orderWay"
        :hideOnNull="item.hideOnNull"
        :filterSelects="item.filterSelects"
        :showExpand="item.showExpand"
        :showFields="item.showFields"
        :createVersion="item.createVersion"
        :itemVersionCreatable="item.itemVersionCreatable"
        :itemVersionLinkCreatable="item.itemVersionLinkCreatable"
        :itemVersionReadable="item.itemVersionReadable"
        :itemDeletable="item.itemDeletable"
        :itemEditable="item.itemEditable"
        :itemLinkCheckable="item.itemLinkCheckable"
        :params="$_getParams(item)"
        :postData="item.postData"
        :sequenceFields="item.sequenceFields"
        :isGetAll="item.isGetAll"
        :modelVersionName="item.modelVersionName"
        :hasSequence="item.hasSequence"
        :hasChapters="item.hasChapters"
        :hasCatchVersion="item.hasCatchVersion"
        :customParentData="item._customParentData"
        :expandDisable="item.expandDisable"
        :filterName="item.filterName"
        :filterSubName="item.filterSubName"
        :isVersionAPI="item.isVersionAPI"
        :itemVersionReadableUrl="item.itemVersionReadableUrl"
        :batchLink="item.batchLink"
        :itemLinkEditable="item.itemLinkEditable"
        @created="$_onCreated($event)"
        @deleted="$_onDeleted($event)"
        @create-btn-click="$emit('create-btn-click')"
      ></WsDataExpandList>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      tabClickedData: "",
    };
  },
  props: {
    tabItems: {
      type: Array,
    },
    tabSetting: {
      type: Array,
    },
    modelData: {
      type: Object,
    },
  },
  methods: {
    $_onCreated($event) {
      this.$emit("created", $event);
    },
    $_onDeleted($event) {
      this.$emit("deleted", $event);
    },
    $_onTabInput($event) {
      this.tabClickedData = $event;
      this.$emit("tab-click", $event);
    },
    $_getParams(item) {
      let _params = {};
      if (item.extendParams) {
        _params = item.extendParams(this.modelData);
      }
      return _params;
    },
  },
  computed: {
    _customParentData() {
      if (this.customParentData) {
        return this.customParentData(this.modelData);
      } else {
        return null;
      }
    },
    _tabCheckedIndex() {
      if (this.tabClickedData) {
        return this.tabClickedData.index;
      } else if (this.tabItems) {
        return 0;
      } else {
        return 0;
      }
    },
  },
};
</script>

<style>
</style>